/**
 * Pure helper functions extracted from auction_channel.js
 * HTML builders for real-time auction updates
 */

export function buildActivityBidHTML(bidData) {
  const amount = Number(bidData.amount).toLocaleString('en-US')
  const displayName = escapeHtml(bidData.bidder_display_name || bidData.bidder_username)
  const profileSlug = escapeHtml(bidData.bidder_profile_slug || bidData.bidder_username)

  return `<div class="activity-bid" id="bid-${bidData.id}">
  <div class="activity-bid__icon">
    <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  </div>
  <div class="activity-bid__body">
    <p class="activity-bid__text">
      <a class="activity-bid__user" href="/users/${profileSlug}">${displayName}</a>
      ofertó
      <span class="activity-bid__amount">USD ${amount}</span>
    </p>
    <span class="activity-bid__time">Hace menos de 1 minuto</span>
  </div>
</div>`
}

export function buildCommentHTML(commentData) {
  return `<div class="comment-header">
            <span class="username">${escapeHtml(commentData.user_username)}</span>
            ${commentData.from_seller ? '<span class="seller-badge">Seller</span>' : ''}
            <span class="timestamp">${new Date(commentData.created_at).toLocaleString()}</span>
          </div>
          <div class="comment-content">${escapeHtml(commentData.content)}</div>`
}

export function buildAuctionEndedHTML(data) {
  return `<div class="auction-ended-message">
              <strong>Auction Ended</strong>
              ${data.final_bid ? `<p>Final bid: $${data.final_bid.toLocaleString()}</p>` : '<p>No bids placed</p>'}
            </div>`
}

function escapeHtml(str) {
  const div = document.createElement('div')
  div.textContent = str
  return div.innerHTML
}
